<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Email Marketing</h4>
            <div class="small text-muted">Administración general de las campañas de Email Marketing</div>
          </b-col>          
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col lg="6">               
              <Widget :configWidget="configWidget" reference="list_summary_email_marketing" :hasAccess="configWidget.elements.listSummaryEmailMarketing" />                            
            </b-col>
            <b-col lg="8"></b-col>
          </b-row>
        </b-col>  
        <b-col lg="3">
        
          <b-list-group class="mb-1" v-if="configSubView.elements.configuration">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openConfiguration()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuración</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configurar la conexión para conectarnos al servicio
              </p>
            </b-list-group-item>
          </b-list-group>                     

          <b-list-group class="mb-1" v-if="configSubView.elements.information">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCrudInformation()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Información</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Visualización de toda la información necesaria para las campañas
              </p>
            </b-list-group-item>
          </b-list-group>  

          <b-list-group class="mb-1" v-if="configSubView.elements.reports">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReports()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Reportes</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Métricas en tiempo real de las campañas en Email Marketing
              </p>
            </b-list-group-item>
          </b-list-group>          

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.EMAIL_MARKETING,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.EMAIL_MARKETING,
          profile_id: Profiles.PERSONAL,
          elements: {             
            listSummaryEmailMarketing: true,            
          }
        },
        configSubView: {
          module_id: Modules.EMAIL_MARKETING,
          profile_id: Profiles.PERSONAL,
          elements: {
            configuration: true,
            information: true,
            reports: true,
            php_custom: true,
          }
        },            
        primaryColor: '',             
        arr: {
          PHPCustom: []
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.listSummaryEmailMarketing = Helper.hasAccessWidget(this.configWidget, 'list_summary_email_marketing')      
      /* Fin configuracion */

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.configuration = Helper.showAccessView(this.configSubView, 'configuration')      
      this.configSubView.elements.information = Helper.showAccessView(this.configSubView, 'crudInformation')      
      this.configSubView.elements.reports = Helper.showAccessView(this.configSubView, 'reports')
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */         
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    },    
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openConfiguration() {
        this.$router.push({ name: 'EmailMarketingStaffConfiguration' })
      },      

      openCrudInformation() {
        this.$router.push({ name: 'EmailMarketingStaffCrudInformation' })
      },   

      openReports() {
        this.$router.push({ name: 'EmailMarketingStaffReports' })
      },     

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.EMAIL_MARKETING)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }       
    }    
   
  }
</script>

<style>

</style>
